<template>
  <PageManager
    :iframe-target="`${link}/${pageUrl}`"
    :page="page"
    :overrides="pages"
  >

    <template #before-sidebar>
      <NavigationSidebar
        :pages="pages"
        v-model="page"
      >
        <template v-slot="{ id }">
          <svg v-if="id === CATALOG" xmlns="http://www.w3.org/2000/svg" class="h-5 w-5" viewBox="0 0 20 20" fill="currentColor">
            <path d="M7 3a1 1 0 000 2h6a1 1 0 100-2H7zM4 7a1 1 0 011-1h10a1 1 0 110 2H5a1 1 0 01-1-1zM2 11a2 2 0 012-2h12a2 2 0 012 2v4a2 2 0 01-2 2H4a2 2 0 01-2-2v-4z" />
          </svg>
          <svg v-else-if="id === CATALOG_PRODUCT" xmlns="http://www.w3.org/2000/svg" class="h-5 w-5" viewBox="0 0 20 20" fill="currentColor">
            <path fill-rule="evenodd" d="M5 4a3 3 0 00-3 3v6a3 3 0 003 3h10a3 3 0 003-3V7a3 3 0 00-3-3H5zm-1 9v-1h5v2H5a1 1 0 01-1-1zm7 1h4a1 1 0 001-1v-1h-5v2zm0-4h5V8h-5v2zM9 8H4v2h5V8z" clip-rule="evenodd" />
          </svg>
          <svg v-else-if="id === CATALOG_SEARCH" xmlns="http://www.w3.org/2000/svg" class="h-5 w-5" viewBox="0 0 20 20" fill="currentColor">
            <path d="M9 9a2 2 0 114 0 2 2 0 01-4 0z" />
            <path fill-rule="evenodd" d="M10 18a8 8 0 100-16 8 8 0 000 16zm1-13a4 4 0 00-3.446 6.032l-2.261 2.26a1 1 0 101.414 1.415l2.261-2.261A4 4 0 1011 5z" clip-rule="evenodd" />
          </svg>
          <svg v-else-if="id === ALL_CATEGORIES" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="currentColor" class="w-5 h-5">
            <path fill-rule="evenodd" d="M5.25 2.25a3 3 0 00-3 3v4.318a3 3 0 00.879 2.121l9.58 9.581c.92.92 2.39 1.186 3.548.428a18.849 18.849 0 005.441-5.44c.758-1.16.492-2.629-.428-3.548l-9.58-9.581a3 3 0 00-2.122-.879H5.25zM6.375 7.5a1.125 1.125 0 100-2.25 1.125 1.125 0 000 2.25z" clip-rule="evenodd" />
          </svg>
        </template>
      </NavigationSidebar>
    </template>

    <template #top-left-content>
      <ContextManager
        v-if="link"

        :class="isSearchPage && 'hidden'"
        @product="prod => product = prod"
        @category="cat => category = cat"
      />
    </template>

  </PageManager>
</template>

<script>

import NavigationSidebar from "@/components/SideEditor/NavigationSidebar"
import PageManager from "@/components/SideEditor/PageManager.vue"
import ContextManager from "@/components/SideEditor/Context/ContextManager"

import { mapGetters } from "vuex"

const CATALOG = 'catalog'
const CATALOG_PRODUCT = 'catalog-product'
const CATALOG_SEARCH = 'catalog-search'
const ALL_CATEGORIES = 'catalog-all-categories'

export default {
  components: {
    PageManager,
    ContextManager,
    NavigationSidebar,
  },
  data() {
    return {
      CATALOG, CATALOG_PRODUCT, CATALOG_SEARCH, ALL_CATEGORIES,

      product: null,
      category: null,

      page: null,
      pages: [
        {
          name: "Category products",
          id: CATALOG,
        },
        {
          name: "Product page",
          id: CATALOG_PRODUCT,
        },
        {
          name: "Catalog search",
          id: CATALOG_SEARCH,
        },
        {
          name: "All Categories",
          id: ALL_CATEGORIES,
        },
      ],
    }
  },
  beforeDestroy() {
    this.$store.dispatch("editor/context", null)
  },
  methods: {
    removeDomainFromPageUrl(url) {
      url = url.replace(this.link, "")
      if (url[0] === "/") url = url.slice(0)
      return url == "null"
        ? null
        : url.replace("index.php", "")
    }
  },
  computed: {
    ...mapGetters({
      link: 'editor/fullDomainLink',
      context: 'editor/context',
    }),

    catalogPage() {
      return this.link && this.category && this.removeDomainFromPageUrl(this.category.to)
    },
    productPage() {
      return this.link && this.product && this.removeDomainFromPageUrl(this.product.url)
    },
    isSearchPage() {
      return this.page === CATALOG_SEARCH
    },
    pageUrl() {
      switch (this.page) {
        case CATALOG: return this.catalogPage
        case CATALOG_PRODUCT: return this.productPage
        case CATALOG_SEARCH: return "catalogsearch/result/?q=a"
        case ALL_CATEGORIES: return "all-categories"
      }
    },
  },
}

</script>
